export default __webpack_public_path__ + "static/media/gatsby.9f365456.svg";